import { Archive } from './sections/archive/archive';

export const UserArchive = () => {
  return <Archive />
};
